/* eslint-disable prettier/prettier */
import React from 'react';
import { useTicketConfig } from '../../hooks/ticket';

function Overview({ team, staff, show }) {
  const [ticketConfig] = useTicketConfig(team?.abbrv);
  const { info } = team;

  const ticketUrl = ticketConfig?.ticketUrl;

  const infoToUse = info.filter(
    (i) => !i.name.includes('Hemmaarena') && i.name !== ''
  );
  const staffFiltered = staff.filter(
    (i) => i.role === 'Head Coach' && i.fullName !== ''
  );

  if (staffFiltered.length > 0) {
    staffFiltered.map((item) =>
      infoToUse.push({
        name: 'Huvudtränare',
        value: `${item.givenName} ${item.surName}`,
      })
    );
  }

  if (!show) return null;

  return (
    <div className="data-container mt-4">
      {infoToUse.map((item) => (
        <div
          key={item.name}
          className="data-container__row text-small text-lg-regular d-flex px-2 px-lg-4 py-2"
        >
          <div className="col-4">
            <strong>{item.name}</strong>
          </div>
          <div className="col-8">
            {item.name.toLowerCase() === 'officiell hemsida:' ||
            item.name.toLowerCase() === 'officiell supporterklubb:' ? (
              <span
                className="children-links children-links--primary fw-bold"
                dangerouslySetInnerHTML={{ __html: item.value }}
              />
            ) : (
              item.value
            )}
          </div>
        </div>
      ))}
      <div className="data-container__row text-small text-lg-regular d-flex px-2 px-lg-4 py-2">
        <div className="col-4">
          <strong>Biljetter</strong>
        </div>
        <div className="col-8 children-links children-links--primary fw-bold">
          <a href={ticketUrl}>{ticketUrl}</a>
        </div>
      </div>
      <div className="data-container__row text-small text-lg-regular d-flex px-2 px-lg-4 py-2">
        <div className="col-4">
          <strong>Arena</strong>
        </div>
        {team.arena?.originalImageUrl && (
          <div className="col-8 pb-4">
            <img
              className="border-radius-10 mb-3"
              width="100%"
              src={team.arena.originalImageUrl}
              alt=""
            />
            <div className="data-container">
              <div className="data-container__row text-small text-lg-regular d-flex px-2 px-lg-4 py-2">
                <div className="col-4">
                  <strong>Namn</strong>
                </div>
                <div className="col-8">{team.arena.name}</div>
              </div>
              <div className="data-container__row text-small text-lg-regular d-flex px-2 px-lg-4 py-2">
                <div className="col-4">
                  <strong>Kapacitet</strong>
                </div>
                <div className="col-8">{team.arena.spectators}</div>
              </div>
              <div className="data-container__row text-small text-lg-regular d-flex px-2 px-lg-4 py-2">
                <div className="col-4">
                  <strong>Öppnad</strong>
                </div>
                <div className="col-8">{team.arena.built}</div>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

export default Overview;
